<template>
  <div class="template-Dropdown">
    <div class="dropdown">
      <div class="dropdownMenu">
        <div class="menuOption" v-for="(entry, index) in languages" :key="entry.title" :class="{active: index === activeItem}"  @click="clickHandler(index, $event)">
          <p><img v-bind:src="'https://res.cloudinary.com/enginecreative/image/upload/v1599214254/Reydar/Canon/' + entry.flag" alt="">{{ entry.title }}</p>
        </div>
      </div>
      <div class="menuArrow">
        <span class="material-icons">
          keyboard_arrow_down
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanuageSelector',
  data() {
    return {
      activeItem: 0,
      languages: [
        { flag: 'BritishFlag_xg2nd6.png', language: 'en', title: 'English' },
        { flag: 'SpanishFlag_lt7pei.png', language: 'es', title: 'Español' },
        { flag: 'FrenchFlag_in7ld8.png', language: 'fr', title: 'Français' },
        { flag: 'ItalianFlag_r4cg9b.png', language: 'it', title: 'Italiano' },
        { flag: 'GermanFlag_iu55kc.png', language: 'de', title: 'Deutsch' },
        { flag: 'RussianFlag_cwytaz.png', language: 'ru', title: 'Pусский' },
      ]
    };
  },
  methods: {
    spanish(event) {
      // console.log('clicked', event)
      console.log(1)
      this.$emit("selectSpanish", event);
    },
    clickHandler(idx, event) {
      this.activeItem = idx
      this.spanish(event)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.template-Dropdown{
  position: relative;

  .dropdown{
    position: absolute;
    right: 20px;
    top: -40px;
    z-index: 999;
    background-color: #fff;
    border: solid 1px #aaabaf;
    border-radius: 5px;
    overflow: hidden;

    .dropdownMenu{
      height: 37px;
      overflow: hidden;
      cursor: pointer;
      margin-top: 0px;

      .menuOption{
        display: none;
        min-width: 168px;
        padding: 7px 15px;
        padding-right: 45px;

        p{
          margin: 0px;

          img{
            height: 20px;
            width: 20px;
            margin-top: -7px;
            margin-right: 8px;
          }
        }
      }
      .menuOption.active{
        display: block;
      }
    }
  }
  .menuArrow{
    position: absolute;
    right: 6px;
    top: 7px;
  }
}
.template-Dropdown:hover{
  cursor: pointer;

  .dropdownMenu{
    height: 228px;
    box-shadow: 0px 0px 25px 5px rgba(0,0,0,0.3);

    .menuOption{
      display: block;
    }
    .menuOption:first-child{
      border-bottom: solid 1px #aaabaf;
      background-color: #eaeaea;
    }
    .menuOption:hover{
      background-color: #eaeaea;
    }
  }
}
</style>
